import "./table-cell-spacer.scss";

import React from "react";

const TableCellSpacer = () => <td className="generic-table-cell-spacer" />;

export default TableCellSpacer;
